var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.537956 0.464844C0.134489 0.861093 0 1.52151 0 2.31401V31.5044C0 32.2969 0.268978 32.9573 0.672446 33.3535L0.806935 33.4856L17.4836 17.1073V16.9752V16.8431L0.537956 0.464844Z",
    fill: "url(#paint0_linear_3707_37370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8634 22.6567L17.3493 17.2413V16.9772V16.8451L22.8634 11.4297L22.9979 11.5618L29.5879 15.2601C31.4707 16.3168 31.4707 18.0338 29.5879 19.0905L22.8634 22.6567Z",
    fill: "url(#paint1_linear_3707_37370)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0016 22.5241L17.353 16.9766L0.541878 33.487C1.21432 34.1474 2.15575 34.1474 3.36615 33.619L23.0016 22.5241Z",
    fill: "url(#paint2_linear_3707_37370)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0016 11.4283L3.36615 0.465441C2.15575 -0.194975 1.21432 -0.0628918 0.541878 0.597524L17.353 16.9758L23.0016 11.4283Z",
    fill: "url(#paint3_linear_3707_37370)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.8689 22.3906L3.36799 33.2214C2.29208 33.8819 1.35065 33.7498 0.678206 33.2214L0.543716 33.3535L0.678206 33.4856C1.35065 34.0139 2.29208 34.146 3.36799 33.4856L22.8689 22.3906Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.539794 33.2203C0.136327 32.824 0.00183868 32.1636 0.00183868 31.3711V31.5032C0.00183868 32.2957 0.270817 32.9561 0.674284 33.3523V33.2203H0.539794Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M29.589 18.6936L22.8646 22.392L22.9991 22.5241L29.589 18.8257C30.5305 18.2974 30.9339 17.637 30.9339 16.9766C30.9339 17.637 30.396 18.1653 29.589 18.6936Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M3.36223 0.598085L29.5876 15.2593C30.3945 15.7876 30.9325 16.316 30.9325 16.9764C30.9325 16.316 30.529 15.6556 29.5876 15.1272L3.36223 0.466002C1.47938 -0.590663 0 0.201835 0 2.31516V2.44725C0 0.466002 1.47938 -0.45858 3.36223 0.598085Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3707_37370",
    x1: 15.8692,
    y1: 2.06279,
    x2: -6.29392,
    y2: 24.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3707_37370",
    x1: 32.0548,
    y1: 16.9792,
    x2: -0.487412,
    y2: 16.9792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3707_37370",
    x1: 19.9445,
    y1: 20.0095,
    x2: -10.1105,
    y2: 50.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3707_37370",
    x1: -3.63105,
    y1: -9.20806,
    x2: 9.78984,
    y2: 4.45731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.9edaed41.svg";
export { ForwardRef as ReactComponent };